import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=e966b7ec"
import script from "./Speaker.vue?vue&type=script&lang=js"
export * from "./Speaker.vue?vue&type=script&lang=js"
import style0 from "./Speaker.vue?vue&type=style&index=0&id=e966b7ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports